"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _loginConnector = _interopRequireDefault(require("../../../../../login/login-connector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *******************************************************************************
// Display the possible races
// *******************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
const EligibleRace = (0, _loginConnector.default)(
// *******************************************************************************
// Display the possible races
// *******************************************************************************

class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isLoading: false
    });
    // Setting values
    _defineProperty(this, "_setLoading", result => {
      this.setState({
        loading: true
      });
      result.then(() => this.setState({
        loading: false
      }), () => this.setState({
        loading: false
      }));
    });
    // Button Actions
    _defineProperty(this, "_onNewEntry", e => {
      e.preventDefault();
      const isWait = false;
      this._setLoading(this.props.onNewEntry(this.state, isWait));
    });
    _defineProperty(this, "_onAddToWaitingList", e => {
      e.preventDefault();
      const isWait = true;
      this._setLoading(this.props.onNewEntry(this.state, isWait));
    });
  }
  render() {
    if (!this.props.loaded) {
      return _ref;
    }
    const raceEligibility = this.props.raceEligibility;
    const race = raceEligibility.race;
    const racesPerClassDiv = this.props.racesPerClassDiv;
    return /*#__PURE__*/_react.default.createElement("tr", null, !(this.props.i % racesPerClassDiv === 0) ? null : [/*#__PURE__*/_react.default.createElement("td", {
      rowSpan: racesPerClassDiv,
      key: "comp"
    }, this.props.competitionName), /*#__PURE__*/_react.default.createElement("td", {
      rowSpan: racesPerClassDiv,
      key: "race"
    }, race.raceName)], /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(race.competitionDay.dayDate, 'ddd')), /*#__PURE__*/_react.default.createElement("td", {
      className: raceEligibility.eligibilityStatus.textClass
    }, raceEligibility.eligibilityStatus.text || (race.competitionDivision.isFreeToEnter ? 'free' : '')), /*#__PURE__*/_react.default.createElement("td", {
      className: "pull-xs-right"
    }, raceEligibility.eligibilityStatus.canEnterNow ? this.props.newEntry.hasPaid || race.competitionDivision.isFreeToEnter ? /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      loading: this.state.loading,
      onClick: this._onNewEntry
    }, "Accept Entry") : /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      loading: this.state.loading,
      onClick: this._onAddToWaitingList
    }, "Add to Waiting List") : !raceEligibility.eligibilityStatus.canAddToWaitingList ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      loading: this.state.loading,
      onClick: this._onAddToWaitingList
    }, "Add to Waiting List")));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(EligibleRace, undefined, (client, props) => ({
  onNewEntry(state, isWait) {
    if (props.newEntry.cseBibID > 0) {
      return client.update('Entry.create', {
        classDivisionID: props.newEntry.classDivisionID,
        cseBibID: props.newEntry.cseBibID,
        raceID: props.raceEligibility.race.id,
        waitList: isWait,
        contactEmail: props.newEntry.contactEmail,
        hasPaid: props.newEntry.hasPaid,
        isOnlineEntry: false,
        entryReceivedDate: props.newEntry.entryReceivedDate
      });
    } else {
      return client.update('Entry.createNonRankedEntry', {
        startListBib: props.newEntry.startListBib,
        bibName: props.newEntry.bibName,
        paddlerClubID: props.newEntry.paddlerClubID,
        yearOfBirth: props.newEntry.yearOfBirth,
        classDivisionID: props.newEntry.classDivisionID,
        raceID: props.raceEligibility.race.id,
        yearID: props.yearID,
        entryTypeID: props.raceEligibility.entryTypeID,
        waitList: isWait,
        contactEmail: props.newEntry.contactEmail,
        entryReceivedDate: props.newEntry.entryReceivedDate,
        hasPaid: props.newEntry.hasPaid,
        isOnlineEntry: false
      });
    }
  }
}));